import { PUT_SURVEY } from 'constants/api'
import Button from 'components/button'
import MultiSelect from 'components/multi-select'
import { LoaderContext } from 'contexts/loader-context'
import { useSession } from 'contexts/session-context'
import { useContext, useEffect, useState } from 'react'
// import SurveyService from "services/survey.services"
import textServices from 'services/text-services'
import useRouter from 'hooks/use-router'
// import { SurveyAdapter } from "views/raffles/types"
import { AxiosError } from 'axios'
import DropDown from './components/dropdown'
import CheckboxMapper from './components/checkbox'
import { TitleSurvey } from './components/styled.components'

function Survey() {
  const [{ survey }, { refetch }] = useSession()
  const { setLoad } = useContext(LoaderContext)
  const { push } = useRouter()
  const [selected, setSelected] = useState<Record<string, number[]>>({})
  const { query }: { query: { url?: string } } = useRouter()
  const decode = decodeURI(query?.url ?? '')

  useEffect(() => {
    if (survey?.length === 0 || !survey) {
      push(decode ?? '/home')
    }
  }, [survey])

  const handleSubmit = async (select: number[]) => {
    if (select.length < survey.length) return alert('Selecciona al menos una opción en cada pregunta')
    setLoad(true)
    try {
      await refetch({ method: 'PUT', data: { optionIds: select }, url: PUT_SURVEY + SURVEY_TYPE })
    } catch (error) {
      const err = error as AxiosError
      return push(`/error/${err}`)
    } finally {
      setLoad(false)
    }
  }

  return (
    <div className="w-full">
      <TitleSurvey className="font-black text-4xl text-center py-4">{textServices.findByText('survey/title', 'CUÉNTANOS')}</TitleSurvey>
      <div className='flex flex-col items-center gap-2 p-4 md:mt-10'>
        {survey?.map(({ question, options, type }, index) => {
          if (type === 'Normal')
            return (
              <MultiSelect
                key={index}
                title={question}
                items={options}
                onChange={(data, select) => setSelected((state) => ({ ...state, [data]: select.map((id) => +id) }))}
              />
            )
          if (type === 'Dropdown')
            return (
              <DropDown
                key={index}
                title={question}
                items={options}
                onChange={(data, select) => setSelected((state) => ({ ...state, [data]: select.map((id) => +id) }))}
              />
            )
          if (type === 'Checkbox')
            return (
              <CheckboxMapper
                key={index}
                title={question}
                items={options}
                onChange={(data, select) => setSelected((state) => ({ ...state, [data]: select.map((id) => +id) }))}
              />
            )
          return <></>
        })}
        <Button
          onClick={() =>
            handleSubmit(
              Object.values(selected).reduce((acum, prev) => {
                return [...acum, ...prev]
              }, [])
            )
          }
        >
          {textServices.findByText('survey/button', 'ACTUALIZAR')}
        </Button>
      </div>
    </div>
  )
}

export default Survey
